<template>
  <div class="mailing-settings">
    <div class="mailing-page__settings-channels">
      <div class="setting-channel">
        <div class="setting-channel__title">{{$tMailing('channel_comment_1')}}</div>
        <div class="setting-channel__inner">

          <div class="setting-channel__wrap"
               :class="{_active:activatedChannel('viber') || activeChannel === 'viber'}">
            <div @click="setChannel('viber')" class="setting-channel__item _viber">
              <BaseSvg name="ico-viber" width="3.1rem" height="3.2rem"/>
            </div>
            <div class="setting-channel__name">Viber</div>
            <span class="tick">
              <span>
                <BaseSvg name="ico-check"/>
              </span>
            </span>
          </div>
          <div class="setting-channel__wrap"
               :class="{_active:activatedChannel('telegram') || activeChannel === 'telegram'}">
            <div @click="setChannel('telegram')" class="setting-channel__item _telegram">
              <BaseSvg name="ico-telegram" width="3.5rem" height="3.2rem"/>
            </div>
            <div class="setting-channel__name">Telegram</div>
            <span class="tick">
              <span>
                <BaseSvg name="ico-check"/>
              </span>
            </span>
          </div>
          <div class="setting-channel__wrap"
               :class="{_active:activatedChannel('email') || activeChannel === 'email'}">
            <div @click="setChannel('email')" class="setting-channel__item _email">
              <BaseSvg name="ico-email" width="2.9rem" height="2.4rem"/>
            </div>
            <div class="setting-channel__name">Email</div>
            <span class="tick">
              <span>
                <BaseSvg name="ico-check"/>
              </span>
            </span>
          </div>
          <div class="setting-channel__wrap"
               :class="{_active:activatedChannel('sms') || activeChannel === 'sms'}">
            <div @click="setChannel('sms')" class="setting-channel__item _sms">
              <BaseSvg name="ico-phone" width="2.3rem" height="3.5rem"/>
            </div>
            <div class="setting-channel__name">SMS</div>
            <span class="tick">
              <span>
                <BaseSvg name="ico-check"/>
              </span>
            </span>
          </div>

          <div class="setting-channel__wrap _disabled">
            <div class="setting-channel__item">
              <BaseSvg name="ico-whatsapp" width="3.1rem" height="3.1rem"/>
            </div>
            <div class="setting-channel__name">WhatsApp</div>
            <span class="tick">
              <span>
                <BaseSvg name="ico-check"/>
              </span>
            </span>
          </div>

          <div class="setting-channel__wrap _disabled">
            <div class="setting-channel__item">
              <BaseSvg name="ico-messenger" width="3.1rem" height="3rem"/>
            </div>
            <div class="setting-channel__name">Messenger</div>
            <span class="tick">
              <span>
                <BaseSvg name="ico-check"/>
              </span>
            </span>
          </div>

          <div class="setting-channel__wrap _disabled">
            <div class="setting-channel__item">
              <BaseSvg name="ico-skype" width="3rem" height="3rem"/>
            </div>
            <div class="setting-channel__name">Skype</div>
            <span class="tick">
              <span>
                <BaseSvg name="ico-check"/>
              </span>
            </span>
          </div>

          <div class="setting-channel__wrap _disabled">
            <div class="setting-channel__item">
              <BaseSvg name="ico-slack" width="2.8rem" height="2.8rem"/>
            </div>
            <div class="setting-channel__name">Slack</div>
            <span class="tick">
              <span>
                <BaseSvg name="ico-check"/>
              </span>
            </span>
          </div>

        </div>
        <div class="setting-channel__comment">
          <BaseSvg name="ico-info"/>
          <span>{{$tMailing('channel_comment_2')}}</span>
        </div>
      </div>
    </div>
    <div class="mailing-page__settings-footer">
      <div class="setting-channel__title">{{$tMailing('Periodicity')}}</div>
      <div class="mailing-page__settings-footer-buttons">
        <button @click="activateChannel(0)"
                :class="{_active: period === 0 }"
                class="base-btn base-btn base-btn--outline-grey--green base-btn--small">
          <BaseSvg name="ico-tick" width="1.5rem" height="1.1rem"/>
          <span class="base-btn__text">{{$tMailing('Every hour')}}</span>
        </button>

        <button @click="activateChannel(1)"
                :class="{_active: period === 1 }"
                class="base-btn base-btn base-btn--outline-grey--green base-btn--small">
          <BaseSvg name="ico-tick" width="1.5rem" height="1.1rem"/>
          <span class="base-btn__text">{{$tMailing('Every day')}}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '../axios'

  export default {
    name: "MailingSettings",
    data() {
      return {
        channels: [],
        period: 0,
        activeChannel: ''
      }
    },
    methods: {
      getChannels() {
        return http.get('/api/cabinet/mailing/get-channel').then(({data}) => {
          this.channels = data.data.channel.split(',')
          this.period = data.data.frequency
        }).finally(() => {
          if (!this.channels.length) {
            return this.setChannel('email')
          }
          this.pending = false
        })
      },
      activatedChannel(channel) {
        return this.channels.find((item) => item === channel)
      },
      setChannel(value) {
        this.activeChannel = value;
        let sendData = {}
        sendData.channel = value;
        sendData.frequency = 0;
        /*if(this.activatedChannel(value)) {
          this.channels.splice(value, 1)
        } else {
          this.channels.push(value)
        }*/

        http.post('/api/cabinet/mailing/set-channel', sendData).then(({data}) => {
          if(value === 'telegram') {
            this.runTelegramSuccess(data.data.secure_code)
          }
        }).finally(() => {
          this.getChannels()
        })
      },
      activateChannel(period) {
        this.period = period
        let sendData = {}
        sendData.channel = this.activeChannel
        sendData.frequency = this.period

        http.post('/api/cabinet/mailing/set-channel', sendData).then(() => {
        }).finally(() => {
          this.getChannels()
        })

      },
      runTelegramSuccess(code) {
        this.$vModal.open('telegram-success', {
          code
        })
      }
    },
    async created() {
      await this.getChannels()
    }
  }
</script>

<style scoped>

</style>
